// extracted by mini-css-extract-plugin
export default {"overlay":"overlay---C_zXt"};